
import { sendGet } from './../helpers/axios';

export const apiDetailDepartment = (divisionId, params) => sendGet(`/api/division/${divisionId}`, params);

export const apiDetailMember = (memberId, params) => sendGet(`/api/user/${memberId}`, params);

export const apiOtherMember = (params) => sendGet(`/api/division/member-other/${params?.departmentId}`);
